import React from 'react';
import './BlogPage.css';
import { Typography, Row, Col, Card, Tag, Space } from 'antd';
import { CalendarOutlined, TagOutlined, ClockCircleOutlined, ArrowRightOutlined, MessageOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useSEO } from '../../shared/ui/SEOHead';

const { Title, Text, Paragraph } = Typography;

const articles = [
    {
        slug: 'kak-vybrat-buket-na-8-marta',
        title: 'Как выбрать идеальный букет на 8 Марта: гайд от флориста',
        excerpt: 'Тюльпаны, мимоза, розы или пионы? Рассказываем, какие цветы выбрать под характер, возраст и бюджет, чтобы подарок запомнился надолго.',
        category: 'Советы',
        date: '2025-02-15',
        readTime: '5 мин',
        image: '🌷',
        content: `
            <h2>Главные цветы 8 Марта</h2>
            <p><strong>Тюльпаны</strong> — классика праздника. Символ весны, нежности и обновления. Держатся 5–7 дней. Идеальны для коллег, подруг, мам.</p>
            <p><strong>Мимоза</strong> — солнечная, пушистая, ароматная. Держится 3–5 дней. Лучше в составе с другими цветами — сама по себе хрупкая.</p>
            <p><strong>Розы</strong> — универсальный вариант. Розовые — нежность, красные — признание, белые — уважение, жёлтые — дружба (да, это не разлука, это миф).</p>
            <p><strong>Пионы</strong> (если уже есть в продаже) — роскошь, пышность, женственность. Держатся 7–10 дней. Самый «вау-эффект».</p>
            
            <h2>Под характер и возраст</h2>
            <ul>
                <li><strong>Девушка 18–25 лет:</strong> яркие тюльпаны, герберы, ранункулюсы, микс в коробке</li>
                <li><strong>Женщина 25–35:</strong> пионы, садовые розы, лилии, авторские букеты в трендовых оттенках</li>
                <li><strong>Мама / бабушка:</strong> нежные розы, хризантемы, альстромерии — долго держатся, невероятно красивы</li>
                <li><strong>Коллега / учитель:</strong> сдержанные моно-букеты: белые розы, кремовые тюльпаны, эустомы</li>
            </ul>
            
            <h2>5 правил выбора</h2>
            <ol>
                <li><strong>Спросите у флориста.</strong> Мы знаем, что сегодня самое свежее.</li>
                <li><strong>Смотрите на бутон.</strong> Не завявший, не слишком раскрытый — в фазе «готов раскрыться».</li>
                <li><strong>Проверяйте стебель.</strong> Твёрдый, зелёный, без пожелтений.</li>
                <li><strong>Упаковка важна.</strong> Аквабокс = вода внутри = свежесть в пути.</li>
                <li><strong>Заказывайте заранее.</strong> 6–7 марта лучший выбор, 8 утра — то, что осталось.</li>
            </ol>
            
            <p><em>В «Ванили» бесплатная консультация флориста: звоните +7 (987) 258-81-11 или пишите в <a href="https://t.me/aurica2025">Telegram</a>. Соберём идеальный букет под ваш бюджет и вкус.</em></p>
        `
    },
    {
        slug: 'ukhod-za-tyulpany-doma',
        title: 'Уход за тюльпанами дома: как продлить жизнь букета на неделю',
        excerpt: 'Тюльпаны продолжают расти в вазе! Рассказываем секреты: правильная вода, обрезка, температура и лайфхак с монеткой, чтобы они стояли 7–10 дней.',
        category: 'Уход за цветами',
        date: '2025-03-01',
        readTime: '4 мин',
        image: '🌷',
        content: `
            <h2>Почему тюльпаны — особенные</h2>
            <p>Тюльпаны — редкие цветы, которые <strong>продолжают расти после среза</strong>. За ночь стебель может удлиниться на 2–3 см, бутон поворачивается к свету. Это нормально — значит, цветок жив и здоров.</p>
            
            <h2>5 правил долгой жизни</h2>
            <ol>
                <li><strong>Холодная вода.</strong> Тюльпаны любят холод. Воду меняйте ежедневно, температуру 4–6°C (можно добавить кубик льда).</li>
                <li><strong>Почти без листьев.</strong> Уберите все листья, которые будут в воде — они гниют и портят воду.</li>
                <li><strong>Обрезка под углом.</strong> Каждый день срезайте стебли на 1–2 см под углом 45° — открывает сосуды для всасывания воды.</li>
                <li><strong>Далеко от батарей и фруктов.</strong> Жара ускоряет раскрытие, этилен от фруктов — завядание.</li>
                <li><strong>Монетка на дне.</strong> Медная монета (или кусочек медного провода) — природный бактерицид. Вода остаётся чистой дольше.</li>
            </ol>
            
            <h2>Что делать, если тюльпаны «положились»</h2>
            <p>Оберните букет газетой/крафтом, погрузите в глубокую вазу с ледяной водой на 2–3 часа (бутоны выше воды). Стебли станут твёрдыми снова.</p>
            
            <p><em>В «Ванили» даём инструкцию по уходу к каждому букету. Заказывайте тюльпаны с доставкой — привезём в аквабоксе, они стоят дольше.</em></p>
        `
    },
    {
        slug: 'top-5-rasteniy-dlya-ofisa',
        title: 'Топ-5 неприхотливых растений для офиса: выживут даже с вами',
        excerpt: 'Сансевиерия, ЗЗ-растение, эпипремнум, хлорофитум, аспидстра — нужен минимум ухода, максимум пользы. Подборка для темных углов и кондиционеров.',
        category: 'Растения',
        date: '2025-03-10',
        readTime: '6 мин',
        image: '🌿',
        content: `
            <h2>Критерии идеального офисного растения</h2>
            <ul>
                <li>Выносит сухой воздух от кондиционеров</li>
                <li>Растёт при искусственном свете / северном окне</li>
                <li>Не требует частых поливов (раз в 2 недели — ок)</li>
                <li>Не выбрасывает аллергенов, не токсично для кошек (важно!)</li>
                <li>Очищает воздух от формальдегида, бензола, ксилола</li>
            </ul>
            
            <h2>Топ-5</h2>
            <ol>
                <li><strong>Сансевиерия (тещин язык)</strong> — король выживания. Северное окно, полив раз в 3 недели, очищает воздух ночью. Есть компактные сорта (Hahnii) для стола.</li>
                <li><strong>Замиокулькас (ЗЗ-растение)</strong> — второй по выносливости. Глянцевые листья, растёт в тени, полив раз в 2–3 недели. «Посадил и забыл».</li>
                <li><strong>Эпипремнум (золотой потос)</strong> — ампельная лиана, красиво спускающаяся по полкам и кашпо. Подходит для северных и южных окон, полив раз в неделю. Легко укореняется и очищает воздух.</li>
                <li><strong>Хлорофитум (зелёная лилия)</strong> — чемпион по очистке воздуха (NASA). Даёт «дочурки» на длинных усах — бесплатное размножение. Полив 1 раз в неделю.</li>
                <li><strong>Аспидстра (семейное счастье)</strong> — легендарная выносливость. Выносит темноту, холод, сквозняки, засуху. Листья до 60 см, выглядит солидно.</li>
            </ol>
            
            <p><em>Хотите украсить дом или рабочее место живыми растениями? Звоните +7 (987) 258-81-11 — поможем выбрать неприхотливые комнатные цветы в наличии!</em></p>
        `
    },
    {
        slug: 'svadebnyy-buket-nevesty-vybor',
        title: 'Букет невесты 2025: тренды, формы и цветы — что выбрать',
        excerpt: 'Каскад, шар, арм-букет, хоуп — какая форма подойдёт к вашему платью? Трендовые цветы сезона: пионы, садовые розы, ранкункулюсы, анемоны. Советы флориста.',
        category: 'Свадьбы',
        date: '2025-04-01',
        readTime: '7 мин',
        image: '👰',
        content: `
            <h2>Формы букета невесты 2025</h2>
            <ul>
                <li><strong>Шар (round) —</strong> классика, идеален для пышных платьев, силуэта «принцесса» и А-силуэта. Компактный и удобный.</li>
                <li><strong>Каскад (cascade) —</strong> водопад цветов вниз. Изящно и торжественно, подходит для платьев со шлейфом.</li>
                <li><strong>Арм-букет (presentation) —</strong> лежит на руке горизонтально. Модно, минималистично, для современных платьев прямого кроя.</li>
                <li><strong>Хоуп (hoop) —</strong> кольцо из цветов/веток. Трендовый вариант, лёгкий и удобный.</li>
                <li><strong>Мини-букет —</strong> компактный букетик для росписи в ЗАГСе или камерного торжества.</li>
            </ul>
            
            <h2>Трендовые цветы сезона</h2>
            <p><strong>Пионы</strong> — классика летнего сезона. Пышные, ароматные и нежные.</p>
            <p><strong>Садовые розы (David Austin)</strong> — чашевидные, с изысканным ароматом. Кремовые, пыльно-розовые, персиковые оттенки.</p>
            <p><strong>Ранункулюсы</strong> — многослойные, стойкие и утончённые цветы пастельных тонов.</p>
            <p><strong>Анемоны</strong> — графичные цветы с контрастным центром. Создают выразительный акцент.</p>
            <p><strong>Эустома и гипсофила</strong> — добавляют букету воздушности и лёгкости.</p>
            
            <h2>Советы невесте</h2>
            <ol>
                <li>Заказывать букет заранее — чтобы флористы успели забронировать самые свежие нужные сорта под вашу дату.</li>
                <li>Показать фото платья и общую палитру — флорист подберёт гармоничную форму и оттенки.</li>
                <li>Не забыть про бутоньерку жениха — она собирается в едином стиле с букетом невесты.</li>
            </ol>
            
            <p><em>Флористы «Ванили» соберут для вас нежный букет невесты и гармоничную бутоньерку жениха. Напишите нам в <a href="https://t.me/aurica2025">Telegram</a> или позвоните +7 (987) 258-81-11 — обсудим детали и подберём цветы к вашему образу.</em></p>
        `
    },
    {
        slug: 'yazyk-cvetov-chto-dayut',
        title: 'Язык цветов: что означают розы, пионы, тюльпаны и лилии — шпаргалка',
        excerpt: 'Розовые розы — нежность, жёлтые — дружба (не разлука!), пионы — счастье, лилии — чистота. Как сказать «люблю», «извини», «горжусь» без слов.',
        category: 'Советы',
        date: '2025-04-15',
        readTime: '5 мин',
        image: '🌹',
        content: `
            <h2>Розы — короли значения</h2>
            <ul>
                <li><strong>Красные:</strong> страстная любовь, признание</li>
                <li><strong>Розовые:</strong> нежность, восторг, благодарность, первое влюбление</li>
                <li><strong>Белые:</strong> чистота, уважение, начало нового, память</li>
                <li><strong>Жёлтые:</strong> дружба, радость, солнце, поддержка (НЕ разлука — это миф!)</li>
                <li><strong>Оранжевые/коралловые:</strong> восторг, восхищение, страсть, энергия</li>
                <li><strong>Лавандовые/синие:</strong> загадка, очарование, любовь с первого взгляда</li>
            </ul>
            
            <h2>Другие популярные цветы</h2>
            <ul>
                <li><strong>Пионы:</strong> счастье в браке, благополучие, честь, богатство. Идеальны для юбилеев свадьбы.</li>
                <li><strong>Тюльпаны:</strong> объявление в любви (красные), надежда и весна (жёлтые), прощение (белые), королевская власть (фиолетовые).</li>
                <li><strong>Лилии:</strong> чистота, благородство, величие. Белые — духовность, розовые — женственность, оранжевые — страсть.</li>
                <li><strong>Хризантемы:</strong> долгая жизнь, радость, оптимизм. В Японии — императорский цветок.</li>
                <li><strong>Гераберы:</strong> радость, солнце, детская невинность. Поднимают настроение гарантированно.</li>
                <li><strong>Ирисы:</strong> мудрость, надежда, вера, хвалят мужество.</li>
                <li><strong>Орхидеи:</strong> утончённая красота, роскошь, сила, изысканность.</li>
            </ul>
            
            <h2>Готовые комбо для праздничных поводов</h2>
            <table>
                <thead><tr><th>Повод и настроение</th><th>Идеальный состав</th></tr></thead>
                <tbody>
                    <tr><td>Признание в любви и романтика</td><td>Красные розы + белоснежные гипсофилы</td></tr>
                    <tr><td>Нежный комплимент</td><td>Розовые эустомы + пионовидные розы + альстромерии</td></tr>
                    <tr><td>Солнечное настроение и радость</td><td>Жёлтые герберы + хризантемы + солнечные тюльпаны</td></tr>
                    <tr><td>Поздравление мамы</td><td>Розовые пионы + садовые розы + альстромерии</td></tr>
                    <tr><td>День рождения подруги</td><td>Коралловые ранункулюсы + анемоны + эустомы</td></tr>
                    <tr><td>Благодарность / деловой партнёр</td><td>Белые розы + зелень (эвкалипт, аспидистра)</td></tr>
                </tbody>
            </table>
            
            <p><em>Не знаете, что выбрать? В «Ванили» бесплатная консультация флориста: +7 (987) 258-81-11 или <a href="https://t.me/aurica2025">Telegram</a>. Скажем, что означает каждый цветок и соберём букет с правильным посланием.</em></p>
        `
    },
    {
        slug: 'kak-hranit-buket-dolshe',
        title: 'Как хранить букет дольше: 7 правил от флориста «Ваниль»',
        excerpt: 'Вода, обрезка, температура, удобрения, ночь в холодильнике — простые правила, которые продлят жизнь любых цветов на 3–5 дней. Чек-лист для скачивания.',
        category: 'Уход за цветами',
        date: '2025-05-01',
        readTime: '5 мин',
        image: '💧',
        content: `
            <h2>Золотое правило: аквабокс</h2>
            <p>Все букеты из «Ванили» едут в <strong>аквабоксе</strong> — специальном резервуаре с водой внизу стеблей. Это даёт +2–3 дня свежести даже в дороге. Не снимайте его сразу!</p>
            
            <h2>7 правил дома</h2>
            <ol>
                <li><strong>Чистая ваза.</strong> Помойте с мылом — бактерии в микротрещинах = быстрая гниль.</li>
                <li><strong>Холодная вода + питание.</strong> Вода 4–8°C. Добавьте саше «Кризаль» (идёт в комплекте) или 1 ч.л. сахара + капля хлора (биocide) на 1 л.</li>
                <li><strong>Обрезка под 45°.</strong> Срежьте 2–3 см от конца каждый день. Не ножницами (сминают сосуды) — острым ножом или секатором.</li>
                <li><strong>Никаких листьев в воде.</strong> Только стебли. Листья гниют за 12 часов.</li>
                <li><strong>Прохладное место ночью.</strong> На балкон (если +5…+10°C) или в холодильник (не морозилку!). Цветы «спят» и экономят ресурс.</li>
                <li><strong>Дальше от фруктов и батарей.</strong> Этилен от яблок/бананов = мгновенное завядание. Жара = испарение влаги.</li>
                <li><strong>Опрыскивание лепестков.</strong> Раз в день пульверизатором — особенно розы, пионы, лилии. Не лейте в бутон!</li>
            </ol>
            
            <h2>СОС: если цветы завяли</h2>
            <p><strong>Шоковая терапия:</strong> обрежьте стебли на 3–5 см, погрузите в ванну с ледяной водой на 2 часа (бутоны выше воды!). Оберните крафтом для поддержки. 80% оживают.</p>
            
            <p><em>В «Ванили» к каждому букету прилагается саше с подкормкой и инструкция по уходу, чтобы цветы радовали вас как можно дольше.</em></p>
        `
    }
];

export const BlogPage: React.FC = () => {
    useSEO({
        title: "Блог о цветах и флористике — советы, уход, тренды | «Ваниль»",
        description: "Полезные статьи от флористов «Ваниль»: как продлить жизнь букету, какие цветы выбрать к празднику, уход за комнатными растениями и свадебные тренды.",
        canonicalUrl: "https://vanilufa.ru/blog"
    });

    return (
        <div className="blog-page">
            <div className="blog-page__container">
                <div className="blog-page__hero">
                    <Title level={1} className="blog-page__title">Блог «Ванили»</Title>
                    <Text type="secondary" className="blog-page__subtitle">
                        Советы флористов, уход за цветами, тренды свадебной флористики и вдохновение
                    </Text>
                </div>

                <Row gutter={[24, 24]} className="blog-page__grid">
                    {articles.map((article, i) => (
                        <Col key={article.slug} xs={24} md={12} lg={8}>
                            <article className="blog-page__card">
                                <div className="blog-page__card-image">{article.image}</div>
                                <div className="blog-page__card-content">
                                    <Space className="blog-page__meta" wrap>
                                        <Tag color="geekblue" icon={<TagOutlined />}>{article.category}</Tag>
                                        <Space><CalendarOutlined /> {new Date(article.date).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })}</Space>
                                        <Space><ClockCircleOutlined /> {article.readTime}</Space>
                                    </Space>
                                    <Title level={3} className="blog-page__card-title">
                                        <Link to={`/blog/${article.slug}`}>{article.title}</Link>
                                    </Title>
                                    <Text type="secondary" className="blog-page__card-excerpt">{article.excerpt}</Text>
                                    <div className="blog-page__card-footer">
                                        <Link to={`/blog/${article.slug}`} className="blog-page__read-more">
                                            <Space>
                                                <Text strong>Читать полностью</Text>
                                                <ArrowRightOutlined />
                                            </Space>
                                        </Link>
                                    </div>
                                </div>
                            </article>
                        </Col>
                    ))}
                </Row>

                <div className="blog-page__cta" style={{ marginTop: 48, textAlign: 'center' }}>
                    <Card className="blog-page__cta-card" variant="borderless">
                        <Space orientation="vertical" size="large">
                            <Title level={3}>Хотите получать свежие статьи и подборки к праздникам?</Title>
                            <Text type="secondary">Подпишитесь на наш Telegram-канал — там анонсы статей, фото работ, спецпредложения и напоминания о 8 Марте, Дне матери, 14 Февраля.</Text>
                            <a href="https://t.me/aurica2025" target="_blank" rel="noopener noreferrer" className="blog-page__subscribe-btn">
                                <Space>
                                    <MessageOutlined /> Подписаться на Telegram
                                </Space>
                            </a>
                        </Space>
                    </Card>
                </div>
            </div>
        </div>
    );
};